<template>
  <b-list-group-item
    lang="de"
    class="keyword pointer list-group-item-action p-0"
    :data-key="keyword.key"
    :active="selectedKeyword === keyword.key"
    @click="setKeyword(keyword.key)"
  >
    <template v-if="editing && selectedKeyword === keyword.key">
      <div class="px-3 py-2" @click.stop>
        <b-input-group>
          <b-textarea
            :ref="'textarea-' + keyword.id"
            v-b-visible="focus(keyword.id)"
            class="px-1 py-0"
            @keydown.prevent.enter="saveKeyword(keyword)"
            @click.stop
            v-model="valueCopy"
            rows="1"
            max-rows="10"
            style="overflow-y: hidden;"
          ></b-textarea>
          <b-input-group-append>
            <b-button size="xs" variant="secondary" @click.stop="saveKeyword(keyword)">
              <b-icon icon="check2"></b-icon>
            </b-button>
          </b-input-group-append>
        </b-input-group>
        <icon-button v-if="keyword.active" class="mt-2 small" @click="deactivateKeyword(keyword)" icon="toggle-on">Deaktivér</icon-button>
        <icon-button v-else class="mt-2 small" @click="reactivateKeyword(keyword)" icon="toggle-off">Genaktivér</icon-button>
        <icon-button v-if="!keyword.in_use && noChildren()" class="mt-2 ml-3 small" icon="trash" @click="deleteKeyword(keyword)">Fjern</icon-button>
      </div>
    </template>
    <template v-else>
      <span class="d-flex justify-content-between align-items-center px-3 py-2">
        <span class="keyword-text d-flex">
          <span :class="!keyword.active ? 'deactivated' : ''">{{keyword.value}}</span>
          <template v-if="selectedKeyword === keyword.key">
            <icon-button class="ml-2 mt-1" icon="pencil-square" @click="startEditing(keyword.value)"></icon-button>
          </template>
        </span>
        <b-badge
          variant="secondary"
          class="ml-2"
          pill
          v-if="keyword.children && keyword.children.length"
        >{{keyword.children.length}}</b-badge>
      </span>
      </template>
  </b-list-group-item>
</template>

<script>
import IconButton from '@/components/IconButton.vue'
export default {
  components: { IconButton },
  props: {
    keyword: {
      type: Object,
      default: function () { return {} }
    },
    selectedKeyword: {
      type: String,
      default: null
    },
    editing: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    selectedKeyword: function () {
      this.valueCopy = this.keyword.value
    },
  },
  data: () => ({
    valueCopy: null
  }),
  mounted() {
    this.valueCopy = this.keyword.value
  },
  methods: {
    noChildren() {
      if (this.keyword.children && this.keyword.children.length) return false
      return true
    },
    setKeyword(key) {
      this.$emit('set', key)
    },
    startEditing(value) {
      this.$emit('startEditing', value)
    },
    focus(id) {
      setTimeout(() => {
        this.$refs['textarea-' + id].focus()
      }, 100)
    },
    saveKeyword() {
      this.$emit('save', this.valueCopy)
    },
    deactivateKeyword(keyword) {
      this.$emit('deactivate', keyword)
    },
    reactivateKeyword(keyword) {
      this.$emit('reactivate', keyword)
    },
    deleteKeyword(keyword) {
      this.$emit('delete', keyword)
    }
  }
}
</script>

<style lang="scss" scoped>
  .keyword {
    span.keyword-text {
      word-break: break-word;
      hyphens: auto;
    }
    &.active {
      position: relative;
    }
  }

  .deactivated {
    opacity: .5;
  }
</style>